<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import ResellerAgentListItem from './components/ResellerAgentListItem';
import NewResellerAgentDialog from './components/NewResellerAgentDialog';
import RbxConfirmDialog from '../../shared/reybex/RbxConfirmDialog';

export default {
  name: 'ResellerAgentList',
  components: {
    ResellerAgentListItem,
    NewResellerAgentDialog,
    RbxConfirmDialog,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Name', value: 'username' },
        { text: 'Email', value: 'email' },
        { text: 'Vorname', value: 'firstname' },
        { text: 'Nachname', value: 'surname' },
        { text: 'Aktionen', value: '', sortable: false },
      ],
      showNewResellerAgentDialog: false,
      isConfirmDialogDisplayed: false,
      confirmDeletionMessage: '',
      resellerAgentToDelete: {},
    };
  },
  computed: {
    ...mapState(['resellerAgentList']),
    ...mapState('resellerAgentList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams).then(() => {
      this.isInitialized = true;
    });
  },
  methods: {
    ...mapActions('resellerAgentList', { fetchData: 'fetchResellerAgentList' }),
    ...mapActions('resellerAgentList', ['deleteResellerAgent', 'deleteResellerAgentList']),
    onDelete(resellerAgentToDelete) {
      this.resellerAgentToDelete = resellerAgentToDelete;
      this.confirmDeletionMessage =
        `Soll die Vertretung ${this.resellerAgentToDelete.username} gelöscht werden?`;
      this.isConfirmDialogDisplayed = true;
    },
    onRefuse() {
      this.isConfirmDialogDisplayed = false;
    },
    onConfirm() {
      this.deleteResellerAgent(this.resellerAgentToDelete)
        .then(() => {
          this.fetchData();
          this.isConfirmDialogDisplayed = false;
        });
    },
  },
};
</script>

<template>
  <div class="user-list">
    <template v-if="resellerAgentList.hasError">
      <p class="js-error-template ma-3">Failed to fetch user list. Please try again!</p>
    </template>
    <template v-else>
      <v-toolbar dark dense height="40" color="blue-grey lighten-2">
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="showNewResellerAgentDialog = true">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Hinzufügen</span>
        </v-tooltip>

        <v-tooltip bottom>
          <v-btn @click="fetchData" icon slot="activator">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Aktualisieren</span>
        </v-tooltip>
      </v-toolbar>

      <v-progress-linear
        v-if="resellerAgentList.isLoading && !isInitialized"
        :indeterminate="true"
        class="js-loading ma-0"
      />

      <v-data-table
        v-else
        :headers="headers"
        :items="resellerAgentList.data"
        :disable-initial-sort="true"
        :pagination="pagination"
        :loading="resellerAgentList.isLoading"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="this.pagination.totalItems"
        :expand="true"
        item-key="id"
        @update:pagination="loadNextPage"
        rows-per-page-text="Zeilen pro Seite"
        no-data-text="keine Daten verfügbar"
        class="elevation-1 js-table"
      >
        <template slot="items" slot-scope="props">
          <reseller-agent-list-item :user="props.item"
                                    :expanded="props.expanded"
                                    @delete="onDelete" />
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
          von {{ pageStart }} bis {{ pageStop }}
        </template>
      </v-data-table>
    </template>

    <NewResellerAgentDialog
      v-if="showNewResellerAgentDialog"
      @cancel="showNewResellerAgentDialog = false"
    />

    <rbx-confirm-dialog @confirm="onConfirm" @refuse="onRefuse"
                        :message="confirmDeletionMessage"
                        :is-displayed="isConfirmDialogDisplayed" />

  </div>
</template>

<style lang="scss" scoped>
.variant-cell {
  width: 30px;

  i {
    cursor: pointer;
  }
}
</style>
